import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { accessLocalStorage, exportSelectAllTrunks, exportDeleteTrunks, fetchEndpoints} from '../../../services';

import PbxContext from '../../../context/PbxContext';
import '../../../libs/bulma.min.css';

import Loading from '../../Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileContract, faTrash, faBook, faPhoneSquareAlt } from '@fortawesome/free-solid-svg-icons';

function EndpointsList() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsChangeFormElements, toggleIsHidden, setItemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [phones, setPhones] = useState(() => []);
  const [trunksSelected, setTrunksSelected] = useState('');
  const [disable, setDisable] = useState(true);

  const history = useHistory();

  const getEndpoints = async () => {
    const trunksList = await exportSelectAllTrunks();
    if(trunksList === undefined) setLoading(true);
    const elements = trunksList.map((element) => element.trunksselect);

    const endpointsAstFetched = await fetchEndpoints();
    const trunksStatus = endpointsAstFetched.filter((trunk) => isNaN(trunk.resource));

    
    setPhones(trunksStatus);
    setLoading(false);
    return true;
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');

    const trunksFetched = await getEndpoints();
    return trunksFetched;
  }, []);

  const handleChangeSelectedTrunks = (element) => {
    // setTrunksSelected((prevState) => {
    //   const onlineState = prevState.includes(element) ? [...prevState.filter((e) => e !== element)] : [...prevState, element];
    //   onlineState.length > 0 ? setDisable(false) : setDisable(true);
    //   return onlineState;
    // });
    // element.length > 0 ? setDisable(false) : setDisable(true);
    setTrunksSelected(element)
    element.length > 0 ? setDisable(false) : setDisable(true);
  };

  const handleClickDelete = async () => {
    // console.log(trunksSelected);
    const sendDeleteTrunks = await exportDeleteTrunks([trunksSelected]);
    if(sendDeleteTrunks.length === undefined) {
      toggleIsHidden('#alert-confirm-trunks-delete');
      return toggleIsChangeFormElements('alert-trunks-not-delete', 'column is-half is-offset-one-quarter message is-danger is-active');
    };
    toggleIsHidden('#alert-confirm-trunks-delete');
    setDisable(true);
    toggleIsHidden('#buttons');

    validateUserLogged();
    return;
  };

  const handleClickUpdate = async () => {
    setItemsSelectedToEdit([trunksSelected]);
    return history.push('/config/tronco/id');
  };

  useEffect(() => {
    let cancel = false;
    
    if (cancel) return;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered">
              <strong className="is-size-3">LISTA DE TRONCOS</strong>
              <hr className="dropdown-divider"/>
            </div>
          </div>
          <article id="alert-trunks-not-delete" name="alert-trunks-not-delete" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-trunks-not-delete') }></button>
            </div>
            <div className="message-body">
              Não foi possível deletar os troncos selecionados.
            </div>
          </article>
          <div className="columns is-half">
            <article id="alert-confirm-trunks-delete" name="alert-confirm-trunks-delete" className="column is-half is-offset-one-quarter message is-danger is-hidden">
              <div className="message-header">
                <p>Atenção!</p>
                <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-confirm-trunks-delete') }></button>
              </div>
              <div className="message-body">
                Tem certeza que quer deletar o(s) tronco(s) selecionado(s)?
              </div>
              <br />
              <div className="columns">
                <div className="column is-half is-offset-one-quarter has-text-centered is-active">
                  <button className="button is-danger is-half mx-3 px-5" type="submit" onClick={ () => handleClickDelete() }>
                        <span className="icon">
                          <FontAwesomeIcon icon={ faTrash } fixedWidth />
                        </span>
                        <span>
                          Confirmar
                        </span>
                  </button>
                  <button className="button is-info is-half mx-3 px-5" type="submit" onClick={ () => {
                    toggleIsHidden('#alert-confirm-trunks-delete')
                    toggleIsHidden('#buttons')
                  }}>
                        <span className="icon">
                          <FontAwesomeIcon icon={ faTrash } fixedWidth />
                        </span>
                        <span>
                          Cancelar
                        </span>
                  </button>
                </div>
              </div>
            </article>
          </div>
          <div className="columns">
          <article className="panel is-info is-4 is-offset-4 column has-text-centered">
            <p className="panel-heading">
              Troncos
            </p>
            {
              phones.map((phone) => {
                const stateColor = phone.state === 'online' ? 'green' : 'gray'; 
                return (
                  <a className="panel-block" key={ phone.resource + phone.state }>
                    {/* <input type="checkbox" value={ phone.resource } onChange={ (e) => handleChangeSelectedTrunks(e.target.value)} /> */}
                    <input name="trunksSelectForEdit" type="radio" value={ phone.resource } onChange={ (e) => handleChangeSelectedTrunks(e.target.value)} />
                    <span className="panel-icon">
                      <FontAwesomeIcon
                        icon={ faPhoneSquareAlt }
                        aria-hidden="true" 
                        className="ml-5" 
                        style={{ color: stateColor }}
                      />
                    </span>
                    <span className="ml-5">{ phone.resource }</span>
                  </a>
                )
              })
            }
          </article>
          </div>
          <div className="columns">
            <div id="buttons" className="column is-half is-offset-one-quarter has-text-centered is-active">
                <button className="button is-info is-half mx-3 px-6" type="submit" onClick={ () => handleClickUpdate() } disabled={ disable }>
                {/* <button className="button is-info is-half mx-3 px-4" type="submit" onClick={ () => handleClickUpdate() } disabled={ true }> */}
                      <span className="icon">
                        <FontAwesomeIcon icon={ faFileContract } fixedWidth />
                      </span>
                      <span>
                        Consultar
                      </span>
                </button>
                <button
                  className="button is-danger is-half mx-3 px-6"
                  type="submit"
                  onClick={ () => {
                    toggleIsHidden('#alert-confirm-trunks-delete')
                    toggleIsHidden('#buttons')
                    }}
                  disabled={ disable }
                >
                      <span className="icon">
                        <FontAwesomeIcon icon={ faTrash } fixedWidth />
                      </span>
                      <span>
                        Deletar
                      </span>
                </button>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default EndpointsList;
